import * as React from 'react';
import { Card, CardContent } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOnOutlined';
import MailIcon from '@mui/icons-material/MailOutline';
import LocalOfferIcon from '@mui/icons-material/LocalOfferOutlined';
import { FilterList, FilterListItem, SavedQueriesList } from 'react-admin';
//import { SavedQueriesList } from '@react-admin/ra-preferences';
import {
    endOfYesterday,
    startOfWeek,
    subWeeks,
    startOfMonth,
    subMonths,
} from 'date-fns';

import SubscriberIcon from '@mui/icons-material/Domain';
import ProductIcon from '@mui/icons-material/LibraryBooks';
import StatusIcon from '@mui/icons-material/CheckCircle';

import CustomFilterList from '../../controls/CustomFilterList';
import CustomFilterSearch from '../../controls/CustomFilterSearch';
import MinLengthFilterLiveSearch from '../../controls/MinLengthFilterLiveSearch';

//import segments from '../segments/data';

const StudentListAside = () => (
    <Card
        sx={{
            display: {
                xs: 'none',
                md: 'block',
            },
            order: -1,
            flex: '0 0 15em',
            mr: 2,
            mt: 4.5,
            alignSelf: 'flex-start',
        }}
    >
        <CardContent sx={{ pt: 1 }}>
            <MinLengthFilterLiveSearch
                source="q"
                variant="outlined"
                minLength={3}
            />
            <SavedQueriesList />
            <CustomFilterList
                url="extralist/student/statuses"
                label="resources.user.filters.status"
                source="status"
                icon={<StatusIcon />}
            />
            <CustomFilterSearch
                url="extralist/schools"
                label="resources.user.filters.schools"
                source="parent_group"
                variant="filled"
                storeKey="student.filters.schools"
                //storeKeyToClear="store.subscription.subscriber_users"
                icon={<SubscriberIcon />}
            />
        </CardContent>
    </Card>
);

export default StudentListAside;
